import { Typography as e } from "../../Typography/Typography.mjs";
import { Icons as t } from "../Icons/Icons.mjs";
import { Button as n } from "../Button/Button.mjs";
import { HStack as r, VStack as i } from "../Primitives/Stack.mjs";
import a from "react";
import { css as o, styled as s } from "styled-components";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
//#region src/components/PageHeader/PageHeader.tsx
var u = s(i)`
    width: 100%;
    gap: ${({ theme: e }) => e.spacing(1)};
    ${({ $sticky: e }) => e && o`
            position: sticky;
            top: 0;
            z-index: 3;
        `}
`, d = s(r)`
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(.75)};
`, f = s.button`
    all: unset;
    cursor: pointer;
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    transition: color ${({ theme: e }) => e.transitions.fast};

    &:hover {
        color: ${({ theme: e }) => e.colors.foreground};
    }
`, p = s.span`
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
`, m = s.span`
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    user-select: none;
`, h = s(r)`
    align-items: center;
    width: 100%;
`, g = "56px", _ = s.div`
    width: ${g};
    height: ${g};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: ${({ theme: e }) => e.radii.md};
    background-color: ${({ theme: e }) => e.colors.muted};
    color: ${({ theme: e }) => e.colors.mutedForeground};

    & > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`, v = s(r)`
    align-items: center;
    flex-wrap: wrap;
    min-width: 0;
`, y = s(i)`
    flex: 1;
    min-width: 0;
`, b = s(r)`
    align-items: center;
    flex-shrink: 0;
`, x = ({ onBack: r, title: i, subTitle: o, leading: s, badge: g, breadcrumbs: x, onBreadcrumbClick: S, children: C, sticky: w, className: T }) => /* @__PURE__ */ l(u, {
	className: T,
	$sticky: w,
	children: [x && x.length > 0 && /* @__PURE__ */ c(d, { children: x.map((e, t) => {
		let n = t === x.length - 1;
		return /* @__PURE__ */ l(a.Fragment, { children: [t > 0 && /* @__PURE__ */ c(m, { children: "/" }), n || !e.href ? /* @__PURE__ */ c(p, { children: e.label }) : /* @__PURE__ */ c(f, {
			onClick: () => S?.(e.href),
			children: e.label
		})] }, t);
	}) }), /* @__PURE__ */ l(h, {
		gap: 2,
		children: [
			r && /* @__PURE__ */ c(n, {
				variant: "ghost",
				size: "icon",
				onClick: r,
				children: /* @__PURE__ */ c(t.ArrowLeft, { size: 16 })
			}),
			s && /* @__PURE__ */ c(_, { children: s }),
			/* @__PURE__ */ l(y, {
				gap: 1,
				children: [g ? /* @__PURE__ */ l(v, {
					gap: 1.5,
					children: [/* @__PURE__ */ c(e, {
						variant: "h4",
						children: i
					}), g]
				}) : /* @__PURE__ */ c(e, {
					variant: "h4",
					children: i
				}), o && (typeof o == "string" ? /* @__PURE__ */ c(e, {
					variant: "body",
					color: "mutedForeground",
					children: o
				}) : o)]
			}),
			C && /* @__PURE__ */ c(b, {
				gap: 2,
				children: C
			})
		]
	})]
});
//#endregion
export { x as PageHeader };
